// extracted by mini-css-extract-plugin
module.exports = {"Items":"brands_Items__vRQLr"};